<template>
    <div class="papsi-wrapper">
        <h1 class="text-2xl font-semibold text-[#24723b] ">Option Modification</h1>
        <p class="text-xs text-[#747474] mt-2">Home / Option Modification / Department</p>
    </div>
    <div class="papsi-wrapper flex mt-7 flex-col">
        <div class="flex items-center gap-5">
            <h1 class="text-[#24723b] font-semibold text-lg">Search/Edit Admin Portal</h1>
            <button v-on:click="HideView" class="bg-[#016B00] w-[180px] text-xs font-semibold p-2 rounded-md text-white hover:bg-[#CCAF12] py-3">+ Add Deparment</button>
        </div>
        <!-- <input class="p-3 mt-3" type="text" placeholder="Search"> -->
        <div class="papsi-container h-[300px]overflow-auto mt-3">
            <div class="mt-8 bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
                <TableControl  :Action="true" :header="header" :column="column" :info="info" :EButton="true" :DButton="false" @EditButton="EditButton" @DeleteButton="DeleteButton"/>
            </div>
        </div>
    </div>
    <div v-if="AddDepartment">
        <div @click="AddDepartment = false" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
        </div>
             <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
                <div class="flex flex-col justify-center  z-40 bg-white w-[500px] text-lg rounded-lg border-[2px] border-[#016B00] relative">
                <div class="pafcpic_header bg-[#016B00] py-3 px-6">
                    <p class="text-[#ffffff] text-md  font-semibold">{{ type }}</p>
                </div>
                <div class="pafcpic_body py-3 px-6">
                    
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Office/Division</p>
                    <select  class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none  overflow-y-auto focus:h-auto" v-model="divisionData">
                        <option selected disabled value="">Select Office/Division</option>
                        <option v-for="(division, index) in division" :key="index" :value="division.division_code">{{ division.division_description }}</option>
                    </select>
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">{{ departmentLabel }}</p>
                    <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#016B00] font-semibold w-full outline-none" placeholder="Input Department" v-model="department">
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">{{ departmentLabelAbbr }}</p>
                    <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#016B00] font-semibold w-full outline-none" placeholder="Input Department Abbreviation" v-model="abbreviation">
                </div>
            <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#00800048] border-t font-medium">
                <button class="text-sm text-white bg-[#016B00] py-1.5 px-7     rounded-md w-[100px] text-center"     v-if="Active === 'Add'" v-on:click="addDeparmentData">Add</button>
                <button class="text-sm text-white bg-[#016B00] py-1.5 px-7     rounded-md w-[100px] text-center"     v-if="Active === 'Update'" v-on:click="editDeparmentData">Update</button>
                <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md w-[100px] text-center" v-on:click="AddDepartment = false">Cancel</button>
            </div>
        </div>
        </div>
    </div>

    <div v-if="Validation">
        <Prompt type="VALIDATION" @close="Validation = false"/>
    </div>

    <div v-if="SuccessAddDepartment">
        <Prompt type="ADDDEPT" @close="SuccessAddDepartment = false"/>
    </div>

    <div v-if="Update">
        <Prompt type="UPDATEOPTION" @close="Update = false"/>
    </div>
 
</template>

<script>
import TableControl from "../controls/TableControl/TableControl.vue"
import Prompt from "./Prompt/RequestPromt.vue"
import Services from "../../services/admin"
import { defineComponent } from "vue";

export default defineComponent({
    components:{
        TableControl,
        Prompt
    },
    data(){
        return{
            departmentLabel:null,
            departmentLabelAbbr:null,
            type:"",
            Update: false,
            SuccessAddDepartment: false,
            Validation:    false,
            info:           null,
            AddDepartment: false,
            TableView:      true, 
            division:         '',
            divisionData:     '',
            Active:           '',
            department:       '',
            abbreviation:     '',
            EditID:           '',
            header:[
                {title:'Department No.'},
                {title:'Department'},
                {title:'Abbreviation'},
                {title:'Action'},
            ],
            column:[
                'department_code',
                'department',
                'abbreviation'
            ],
        }
    },
    mounted(){
        this.getDepartment()
        this.getAllDivision()
    }
    ,
    methods:{
        EditButton(row){
            this.type =     "UPDATE DEPARTMENT"
            this.departmentLabel        =    "Update Department"
            this.departmentLabelAbbr    =    "Enter Updated Department Abbreviation"
            this.AddDepartment          =      true
            this.Active                 =     'Update'
            this.divisionData           =     row.division_code
            this.department             =     row.department
            this.abbreviation           =     row.abbreviation
            this.EditID                 =     row.id
        },
        HideView(){
            this.type =     "ADD DEPARTMENT"
            this.departmentLabel        =    "Create New Department"
            this.departmentLabelAbbr    =    "Create Department Abbreviation"
    
            if (!this.TableView){
                this.TableView     =   true
                this.AddDepartment =  false
            }
            else{
                this.getAllDivision()
                this.Active        =  'Add'
                this.divisionData  =   ''
                this.department    =   ''
                this.abbreviation  =   ''
                this.AddDepartment =   true
            }
        },
        async getDepartment(){
            this.$emit("showLoader")
            this.getAllDivision()
            const success      =  await Services.getDepartment()
            this.info          =  success.data
            this.$emit("hideLoader")
        },
        async getAllDivision(){
            const success      =  await Services.getDivision()
            this.division      =  success.data
        },
        async editDeparmentData(){
            this.$emit("showLoader")
            const success      =  await Services.editDepartment(this.divisionData,this.department,this.abbreviation,this.EditID)
            this.division      =  success.data
            this.AddDepartment =  false
            this.getDepartment()
            this.$emit("hideLoader")
            this.Update        =  true

        },
        async addDeparmentData(){
            if(!this.divisionData || !this.department || !this.abbreviation){
                this.Validation = true
                return
            }
            else{
                const success  = await Services.addDepartment(this.divisionData,this.department,this.abbreviation)
                this.deparment = success.data
                this.AddDepartment = false
                this.getDepartment()
                this.SuccessAddDepartment = true
            }
        }
    }
    

})

</script>

